module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"success":"Success","successMessage1":"Appointment Booked!","successMessage2":"Your {appointmentSummary} has been scheduled.","viewAppointments":"See it on your calendar","ok":"Ok, got it"}}')
  delete Component.options._Ctor
}
